import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Langwrapper from './Langwrapper';
import * as serviceWorker from './serviceWorker';
import reducer from './redux/reducers'
import {createStore, applyMiddleware} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
const store = createStore(reducer, applyMiddleware(thunk))

ReactDOM.render(
  <Provider store={store}>
    <Langwrapper />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
